module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAZBAMAAACrypHYAAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMAgL9ARyeO/QAAAH1JREFUGNNlkcsNwCAIQNu6gAcHMCkD2M8CtOw/U4NYIOJBAd8To0sYV6isba6kPUAlQNsbNGpBQ559+aTMy+H6E8qBWUtAI6asGo7oxl/TzY1q7w8C9Vh2i0GcILMGSZZAIDMJPCTHkEJqGmQm32Qyn/nhFDLTIDNr/CmffHf9EzeZE5kWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/select.png
// module id = j7d7
// module chunks = 1